import { useTaskCount } from 'hooks/useTaskCount';

type TaskTypeCount = { ID: number; label: string; count: number };

type TaskCountSummary = {
  pending: number;
  complete: number;
  overdue: TaskTypeCount[];
  withinOneHour: TaskTypeCount[];
  overOneHour: TaskTypeCount[];
};

const initialState: () => TaskCountSummary = () => ({
  pending: 0,
  complete: 0,
  overdue: [],
  withinOneHour: [],
  overOneHour: [],
});

function useTaskSummary(): { summary?: TaskCountSummary; isLoading: boolean } {
  const { taskCounts: data, isLoading } = useTaskCount();

  const summary = data?.reduce((summary, { ID, label, count, overdue, withinOneHour, complete }) => {
    count && (summary.pending += count);
    complete && (summary.complete += complete);
    overdue && summary.overdue.push({ ID, label, count: overdue });
    withinOneHour && summary.withinOneHour.push({ ID, label, count: withinOneHour });

    const overOneHour = count - (overdue ?? 0) - (withinOneHour ?? 0);
    overOneHour && summary.overOneHour.push({ ID, label, count: overOneHour });

    return summary;
  }, initialState());

  return { summary, isLoading };
}

export { useTaskSummary };
